import OliverText from "@builder/components/general/OliverText";
import "./style.scss";
import { useTranslation } from "react-i18next";

export type SidebarOption = { label: string; value: string; checked: boolean; disabled?: boolean; premiumTag?: boolean };

interface PopupSidebarProps {
    name?: string;
    options: SidebarOption[];
    callback: (options: SidebarOption[], newValue?: string) => void;
    noTranslate?: boolean;
    style?: React.CSSProperties;
    disabled?: boolean;
}

const PopupSidebar = ({ name, options, callback, noTranslate, style }: PopupSidebarProps) => {
    const { t } = useTranslation();

    const handleOptionChange = (e: React.FormEvent<HTMLInputElement>) => {
        const value = e.currentTarget.value;
        if (value) {
            const newOptions: SidebarOption[] = [...options];
            for (let i = 0; i < newOptions.length; i++) {
                newOptions[i].checked = value === newOptions[i].value;
            }
            callback(newOptions, value);
        }
    };

    return (
        <div className="popup-sidebar-wrapper" style={style}>
            {options.map((option, index) => (
                <label key={index} className={option.disabled ? "disabled" : ""}>
                    <input
                        type="radio"
                        name={name}
                        value={option.value}
                        checked={option.checked}
                        onChange={handleOptionChange}
                        disabled={option.disabled}
                    />
                    <div className="custom-radio">
                        <OliverText
                            text={noTranslate ? option.label : t("popup.popupSidebar." + option.label)}
                            size="xs"
                            weight="medium-heavy"
                            color={option.checked ? "blue" : undefined}
                        />
                    </div>
                </label>
            ))}
        </div>
    );
};

export default PopupSidebar;
